import React, { useState } from "react";
import "./CallDetails.css";
import { callhistory, unblockSpamUser } from "../../services/merpservices";
import { encryptForBackend } from "../../utils/encryption/aesEncryption";
import { formatDateMonthYear, formatEnteredDate } from "../../utils/Misc/DateTime";
import DatePicker from "../DatePicker/DatePicker";
import getCookie from "../../utils/GetCookie/getCookie";
import getIP from "../../utils/EmpDetails/getIP";
import { rabbitMQPubAPi } from "../../services/rabbitMq";
import SpamCallReport from "./SpamCallReport";
import {
  getISTDateTime,
  getLastMonthFirstDate,
  getTodayDate,
  getTransactionNumber,
} from "../../functions/CallDetails";
import { set } from "react-ga";
import SpamReportTable from "./SpamReportTable";
import UnblockReportSection from "./UnblockReportSection";

const CallDetails = ({ empid, ak }) => {
  const today = new Date();
  const [startDate, setStartDate] = useState(today.toISOString().split("T")[0]);
  const [endDate, setEndDate] = useState(today.toISOString().split("T")[0]);
  const [glid, setGlid] = useState("");
  const [mobile, setMobile] = useState("");
  const [agentId, setAgentId] = useState("");
  const [ucid, setUcid] = useState("");
  const [paidCallsReport, setPaidCallsReport] = useState(false);
  const [showCallDetailsDump, setShowCallDetailsDump] = useState(3);
  const [callData, setCallData] = useState([]);
  const [spamCallData, setSpamCallData] = useState([]);
  const [message, setMessage] = useState("");
  const [activeRecording, setActiveRecording] = useState(null);
  const [reportType, setReportType] = useState("");
  const [reason, setReason] = useState("");

  const empidstoredData = getCookie("employeeData");
  const employeeDetails = JSON.parse(empidstoredData);

  const empid_array = [
    "50060",
    "29545",
    "37647",
    "93805",
    "85789",
    "93639",
    "100659",
    "64374",
    "94090",
    "107140",
    "113793",
    "113795",
    "113875",
    "86041",
    "106088",
    "1674",
    "3061",
    "106720",
    "117113",
    "96045",
    "113881",
    "113870",
    "95219",
    "102939",
    "89590",
    "99407",
    "113866"
  ];

  const rabbitMQ = async () => {
    const ip = await getIP();
    const transactionNum = `${
      employeeDetails?.empid || empid
    }_${getTransactionNumber()}`;
    const newDateTime = getISTDateTime();
    const data = {
      datefrom: startDate,
      dateto: endDate,
      email: employeeDetails?.EMAIL,
      flag: paidCallsReport,
      ip: getCookie("CCIP") || ip.data?.ip,
      empName: employeeDetails?.EMPLOYEENAME,
      ak: employeeDetails?.ak,
      empid: employeeDetails?.empid,
      transactionNumber: transactionNum,
      dateTime: newDateTime,
    };
    try {
      const res = await rabbitMQPubAPi(data);
      setMessage(
        <p style={{ color: "#006400" }}>
          Your report will be emailed to you soon. Kindly check your gmail
          inbox. Reference ID : <b>#{transactionNum}</b>
        </p>
      );
    } catch (error) {
      console.error("Error in API call", error);
    }
  };

  const fetchCustomerCallHistory = async (datefrom, dateto) => {
    const condition = `&startDate=${datefrom}&endDate=${dateto}&ucid=${ucid}&glid=${glid}&agentid=${agentId}&mobno=${encryptForBackend(mobile)}`;
    try {
      const res = await callhistory(
        employeeDetails?.empid,
        employeeDetails?.ak,
        condition
      );
      if (res?.data?.status === 200) {
        const data = res?.data?.data?.call_report;
        if (data.length > 0) {
          setCallData(res?.data?.data?.call_report);
          setMessage("");
        } else {
          setMessage(<p style={{ color: "red" }}>No records found !!!</p>);
          setCallData([]);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = (e, flag) => {
    e?.preventDefault(); // Prevent default form submission
    const date1 = new Date(startDate);
    const date2 = new Date(endDate);
    const timeDiff = Math.abs(date2.getTime() - date1.getTime());
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

    if (date2 < date1) {
      alert("End Date cannot be less than Start Date!!");
      return false;
    }

    if (flag) {
      if (diffDays > 31) {
        alert("Only 31 days data can be fetch!!");
        return;
      }
      rabbitMQ();
    } else {
      if (glid === "" && ucid === "" && agentId === "" && mobile === "") {
        alert("Please enter any one field GLID, MOBILE, AGENT ID and UCID");
        return;
      }
      fetchCustomerCallHistory(
        formatDateMonthYear(startDate, "DD-MM-YYYY"),
        formatDateMonthYear(endDate, "DD-MM-YYYY")
      );
    }
  };

  const showPlayer = (url) => {
    setActiveRecording(url);
  };
 
  const handleUnBlock = async () => {
    if(!glid) {
      alert("Please enter GLID");
      return;
    }
    if(!reason) {
      alert("Please enter Reason");
      return;
    }
    if(reason.length > 400) {
      alert("Please write reason within 400 characters");
      return;
    }
    try {
      const data = await unblockSpamUser(employeeDetails?.empid, employeeDetails?.ak, glid, "unblock", reason);
      if(data?.data?.status === 200) {
        const message = data?.data?.message;
        if(message === "Success") {
          alert("Number associated with GLID is successfully unblocked");
          setReason("");
          setGlid("");
          return;
        }else if(message === "GLID is not marked spam in the system") {
          alert("GLID is not marked spam in the system");
          setReason("");
          setGlid("");
          return;
        }else{
          alert("Something went wrong, please try again later");
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <>
      {!empidstoredData && (
        <div style={{ textAlign: "center" }}>
          Kindly login before accessing the page
        </div>
      )}
      <div className="calldump-container">
        <div className="calldump-header">Call Recording Details</div>
        <div className="calldump-content">
          <div className="calldump-left-panel">
            <button
              onClick={() => {
                setShowCallDetailsDump(1);
                setMessage("");
                setCallData([]);
                setSpamCallData([]);
              }}
            >
              Call Details Dump
            </button>
            <button
              onClick={() => {
                setShowCallDetailsDump(3);
                setMessage("");
                setSpamCallData([]);
              }}
            >
              Search Call Details
            </button>
            <button
              onClick={() => {
                setShowCallDetailsDump(2);
                setMessage("");
                setCallData([]);
              }}
            >
              Spam Call Report
            </button>
          </div>

          <div className="calldump-right-panel">
            {showCallDetailsDump === 1 ? (
              <>
                <div className="calldump-form-group">
                  <label>
                    Start Date:<span style={{ color: "red" }}>*</span>
                  </label>
                  <DatePicker
                    value={startDate}
                    onChange={(date) => setStartDate(date)}
                    minDate={getLastMonthFirstDate()}
                    maxDate={getTodayDate()}
                  />
                </div>

                <div className="calldump-form-group">
                  <label>
                    End Date:<span style={{ color: "red" }}>*</span>
                  </label>
                  <DatePicker
                    value={endDate}
                    onChange={(date) => setEndDate(date)}
                    minDate={getLastMonthFirstDate()}
                    maxDate={getTodayDate()}
                  />
                </div>

                <div className="calldump-checkbox-group">
                  <label>Paid Calls Report</label>
                  <input
                    type="checkbox"
                    checked={paidCallsReport}
                    style={{ marginRight: "180px" }}
                    onChange={() => setPaidCallsReport(!paidCallsReport)}
                  />
                </div>

                <div className="calldump-buttons">
                  <button
                    onClick={(e) => handleSubmit(e, true)}
                    disabled={!empid_array.includes(employeeDetails?.empid)}
                  >
                    Submit
                  </button>
                </div>
              </>
            ) : showCallDetailsDump === 2 ? (
              <SpamCallReport
                empid={employeeDetails?.empid}
                ak={employeeDetails?.ak}
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
                spamCallData={spamCallData}
                setSpamCallData={setSpamCallData}
                reportType={reportType}
                setReportType={setReportType}
                setMessage={setMessage}
              />
            ) : showCallDetailsDump === 3 ? (
              <>
                <div className="calldump-form-group">
                  <label>
                    Start Date:<span style={{ color: "red" }}>*</span>
                  </label>
                  <DatePicker
                    value={startDate}
                    onChange={(date) => setStartDate(date)}
                  />
                </div>

                <div className="calldump-form-group">
                  <label>
                    End Date:<span style={{ color: "red" }}>*</span>
                  </label>
                  <DatePicker
                    value={endDate}
                    onChange={(date) => setEndDate(date)}
                  />
                </div>

                <div className="calldump-form-group">
                  <label>Gluser Id:</label>
                  <input
                    type="text"
                    name="glid"
                    value={glid}
                    onChange={(e) => setGlid(e.target.value)}
                    placeholder="Gluser Id"
                  />
                </div>

                <div className="calldump-form-group">
                  <label>Mobile:</label>
                  <input
                    type="text"
                    name="mobile"
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                    placeholder="Mobile"
                  />
                </div>

                <div className="calldump-form-group">
                  <label>Agent Id:</label>
                  <input
                    type="text"
                    name="agentid"
                    value={agentId}
                    onChange={(e) => setAgentId(e.target.value)}
                    placeholder="Agent Id"
                  />
                </div>

                <div className="calldump-form-group">
                  <label>Ucid:</label>
                  <input
                    type="text"
                    name="ucid"
                    value={ucid}
                    onChange={(e) => setUcid(e.target.value)}
                    placeholder="Ucid"
                  />
                </div>

                <div className="calldump-buttons">
                  <button onClick={(e) => handleSubmit(e, false)}>
                    Submit
                  </button>
                  <button
                    onClick={() => {
                      setStartDate("");
                      setEndDate("");
                      setGlid("");
                      setMobile("");
                      setAgentId("");
                      setUcid("");
                    }}
                    style={{ marginLeft: "10px" }}
                  >
                    Reset
                  </button>
                </div>
              </>
            ) : null}
          </div>
        </div>
      </div>
      {callData.length > 0 && (
        <div className="custom-container">
          <table className="custom-table">
            <thead>
              <tr>
                <th>UCID</th>
                <th>EMPLOYEE ID</th>
                <th>EMPLOYEE NAME</th>
                <th>GLUSR ID</th>
                <th>CALL RECORDING URL</th>
                <th>ENTERED_ON</th>
                <th>COMMENTS</th>
                <th>FLAG_CALL_TYPE</th>
                <th>CALL_FEEDBACK</th>
                <th>HOSTING_DATE</th>
                <th>SERVICE_NAME</th>
                <th>SERVICE_ID</th>
                <th>OLD CUSTTYPE NAME</th>
                <th>IIL_VERTICAL_NAME</th>
                <th>GL_DISP_GRP_NAME</th>
                <th>GL_DISP_CAT_NAME</th>
                <th>GL_DISP_DESC_NAME</th>
                <th>BRF RAISED</th>
                <th>HOT LEAD</th>
                <th>CONNECT</th>
                <th>OCR</th>
                <th>UPDATE STS</th>
                <th>TICKET OPENED</th>
                <th>TICKET UPDATED</th>
                <th>FCP_FLAG</th>
              </tr>
            </thead>
            <tbody>
              {callData.map((details, index) => {
                const {
                  UCID,
                  FK_EMPLOYEEID,
                  EMPLOYEENAME,
                  FK_GLUSR_USR_ID,
                  CALL_RECORDING_URL,
                  ENTERED_ON,
                  COMMENTS,
                  FLAG_CALL_TYPE,
                  CALL_FEEDBACK,
                  HOSTING_DATE,
                  OLD_CUSTTYPE_NAME,
                  IIL_VERTICAL_NAME,
                  GL_DISP_GRP_NAME,
                  GL_DISP_CAT_NAME,
                  GL_DISP_DESC_NAME,
                  BRF_RAISED,
                  HOT_LEAD,
                  CONECT,
                  UPDATE_STS,
                  UPDATE_STS_NEW,
                  TICKET_OPENED,
                  TICKET_UPDATED,
                  FCP_FLAG,
                  SERVICE_ID,
                  SERVICE_NAME,
                } = details;

                return (
                  <tr key={index}>
                    <td>{UCID}</td>
                    <td>{FK_EMPLOYEEID}</td>
                    <td>{EMPLOYEENAME}</td>
                    <td>{FK_GLUSR_USR_ID}</td>
                    <td
                      onClick={() => showPlayer(CALL_RECORDING_URL)}
                      style={{ cursor: "pointer" }}
                    >
                      {CALL_RECORDING_URL &&
                        activeRecording === CALL_RECORDING_URL && (
                          <div className="audio-container">
                            <audio controls autoPlay>
                              <source src={activeRecording} type="audio/mp3" />
                            </audio>
                          </div>
                        )}
                      {CALL_RECORDING_URL && CALL_RECORDING_URL}
                    </td>
                    <td>{ENTERED_ON}</td>
                    <td>{COMMENTS}</td>
                    <td>{FLAG_CALL_TYPE}</td>
                    <td>{CALL_FEEDBACK}</td>
                    <td>{HOSTING_DATE}</td>
                    <td>{SERVICE_NAME}</td>
                    <td>{SERVICE_ID}</td>
                    <td>{OLD_CUSTTYPE_NAME}</td>
                    <td>{IIL_VERTICAL_NAME}</td>
                    <td>{GL_DISP_GRP_NAME}</td>
                    <td>{GL_DISP_CAT_NAME}</td>
                    <td>{GL_DISP_DESC_NAME}</td>
                    <td>{BRF_RAISED}</td>
                    <td>{HOT_LEAD}</td>
                    <td>{CONECT}</td>
                    <td>{UPDATE_STS}</td>
                    <td>{UPDATE_STS_NEW}</td>
                    <td>{TICKET_OPENED}</td>
                    <td>{TICKET_UPDATED}</td>
                    <td>{FCP_FLAG}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
      {
        <>
          {reportType === "spam" && spamCallData.length > 0 ? (
            <SpamReportTable
              data={spamCallData}
              formatEnteredDate={formatEnteredDate}
            />
          ) : (
            reportType === "unblock" && (
              <UnblockReportSection
                data={spamCallData}
                formatEnteredDate={formatEnteredDate}
                glid={glid}
                reason={reason}
                setGlid={setGlid}
                setReason={setReason}
                handleUnBlock={handleUnBlock}
                empid_array={empid_array}
                employeeDetails={employeeDetails}
              />
            )
          )}
        </>
      }
      {message && <div style={{ textAlign: "center" }}>{message}</div>}
    </>
  );
};

export default CallDetails;
